"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editKybExceptionSchema = exports.proposeKybExceptionSchema = exports.KYB_EXCEPTION_SOFT_WARN_DAYS = exports.KYB_EXCEPTION_MAX_DAYS = exports.KYB_EXCEPTION_RATIONALE_MAX = exports.KYB_EXCEPTION_RATIONALE_MIN = exports.KYB_EXCEPTION_STATUSES = void 0;
const zod_1 = require("zod");
const named_gates_1 = require("./named-gates");
exports.KYB_EXCEPTION_STATUSES = [
    'Pending',
    'Active',
    'Rejected',
    'Expired',
    'Changes_Requested',
];
exports.KYB_EXCEPTION_RATIONALE_MIN = 20;
exports.KYB_EXCEPTION_RATIONALE_MAX = 2000;
exports.KYB_EXCEPTION_MAX_DAYS = 730;
exports.KYB_EXCEPTION_SOFT_WARN_DAYS = 180;
const namedGateSchema = zod_1.z.enum(named_gates_1.KYB_NAMED_GATES.map((g) => g.value));
exports.proposeKybExceptionSchema = zod_1.z
    .object({
    counterparty_id: zod_1.z.string().regex(/^\d+$/u, 'counterparty_id must be a stringified bigint'),
    named_gate: namedGateSchema,
    rationale: zod_1.z.string().trim().min(exports.KYB_EXCEPTION_RATIONALE_MIN).max(exports.KYB_EXCEPTION_RATIONALE_MAX),
    expires_at: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/u, 'expires_at must be ISO date YYYY-MM-DD'),
})
    .strict();
// Editing a sent-back exception only touches the rationale and expiry; the gate and
// counterparty are fixed (changing them would be a different exception, not a revision).
exports.editKybExceptionSchema = exports.proposeKybExceptionSchema
    .pick({ rationale: true, expires_at: true })
    .strict();
//# sourceMappingURL=exception.js.map